import { BookOpenText, GraduationCap, User } from "lucide-react"

import type { WorkspaceDefinition } from "@/components/workspace/definition"
import {
  editLearnersStudent,
  learnersStudentClasses,
  learnersStudentWorkspace,
} from "@/routes"

// A student's workspace: its home page, its destinations in the order the
// workspace page and the role menu list them, and the role's mark in the
// header. The owner id is the student's. The tint is light grey until the
// role is assigned one.
export const studentWorkspace: WorkspaceDefinition = {
  ownerType: "student",
  root: (studentId) => learnersStudentWorkspace({ studentId }).url,
  destinations: [
    {
      key: "profile",
      href: (id) => editLearnersStudent({ id }).url,
      titleKey: "student_workspace:links.profile",
      descriptionKey: "student_workspace:links.profile_description",
      icon: User,
    },
    {
      key: "classes",
      href: (studentId) => learnersStudentClasses({ studentId }).url,
      titleKey: "student_workspace:links.classes",
      descriptionKey: "student_workspace:links.classes_description",
      icon: BookOpenText,
    },
  ],
  namespaces: ["student_workspace"],
  icon: GraduationCap,
  tint: "bg-brand-light-grey",
}
